import { IAdBiddingProviderConfig } from '../..'
import { IAd } from '../../../ad'
export interface IAdBidder {
    initializeBidding(confs: IAdBiddingProviderConfig[], adServer?: string, timeout?: string): void
    requestAds?(target?: EventTarget, allAds?: IAd[], specificAds?: IAd[]): void
    requestAdsPromise?(ads?: IAd[], slot?: any): Promise<any>
    shouldWaitForBidder(): boolean
}
export abstract class AdBiddingBase implements IAdBidder {
    protected abstract URLPath: string
    protected waitForBidder = false
    protected amazonEnabled: boolean

    public abstract initializeBidding(confs: IAdBiddingProviderConfig[], adServer?: string, timeout?: string): void
    public abstract requestAds?(target: EventTarget, allAds?: IAd[], specificAds?: IAd[]): void
    public abstract requestAdsPromise?(ads?: IAd[], slot?: any): Promise<any>

    public shouldWaitForBidder(): boolean {
        return this.waitForBidder
    }
}
